import React from 'react';
import t from 'prop-types';
import Pestana from './pestana';

var PestanaIndicador = function PestanaIndicador(_ref) {
  var boton = _ref.boton;
  var clases = ['botonIndicador'];
  return React.createElement(Pestana, {
    boton: boton,
    clases: clases
  });
};

PestanaIndicador.propTypes = process.env.NODE_ENV !== "production" ? {
  boton: t.object
} : {};
export default PestanaIndicador;